export default {
  form: {
    versions: {
      label: 'Versión',
      placeholder: 'Seleccionar versión',
    },
    font_family: {
      label: 'Familia tipográfica',
    },
    background_color: {
      label: 'Color de fondo',
    },
    promo_frame_primary_color: {
      label: 'Color del marco promocional',
    },
    promo_frame_discount_label_color: {
      label: 'Color de descuento del marco',
    },
    vip_members_cta_color: {
      label: 'Color CTA miembros VIP',
    },
    url_cta_color: {
      label: 'Color CTA de URL',
    },
    url_color: {
      label: 'Color de URL',
    },
    url_type: {
      label: 'URL',
      placeholder: 'Seleccionar URL',
    },
    url: {
      placeholder: 'www.example.com',
    },
    qr_code_border_color: {
      label: 'Color del borde del QR',
    },
    qr_code_background_color: {
      label: 'Color de fondo del QR',
    },
    footer_background_color: {
      label: 'Color de fondo del pie',
    },
    logo_zoom: {
      label: 'Tamaño del logo',
    },
    logo: {
      label: 'Logo',
    },
  },
  toasts: {
    failed_to_load_data: 'Error al cargar el adhesivo',
  },
};
